var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoka(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.085 12.15 2.97-10.857c1.43 2.372 4.365 7.233 4.658 7.702.367.587.183 1.1-.367 1.247-.44.117-5.024 1.32-7.261 1.907z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.212 1.513-2.97 10.856-11.15 2.86 13.68-13.717c.264-.264.403-.11.44 0z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.967 20.474c.235-.44 1.467-5.195 2.054-7.518-3.373.892-10.246 2.707-10.745 2.824-.498.117-.207.293 0 .367 2.189 1.442 6.683 4.379 7.152 4.584.587.258 1.247.295 1.54-.256z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.346 10.866c-.44.087-5.195 1.308-7.518 1.907-.66 2.212-1.995 6.85-2.054 7.701-.059.851.807.697 1.247.514l7.006-1.944c.562-2.09 1.738-6.47 1.944-7.262.257-.99-.074-1.026-.624-.916z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m16.605 1 14.157 14.12c-2.555-1.418-7.82-4.38-8.435-4.878-.616-.499-1.162-1.332-1.357-1.687L16.605 1z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m19.613 18.824 11.15-3.007c-2.25-1.345-6.955-4.152-7.776-4.621-.822-.47-1.32.195-1.467.586l-1.907 7.042z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.028 16.697 19.32 19.704 16.495 31a47130.17 47130.17 0 0 0 13.936-13.863c.499-.499-.061-.501-.403-.44z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m16.019 31 2.823-11.296c-2.09.562-6.477 1.79-7.299 2.2-.821.411-.709 1.076-.55 1.358L16.02 31z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m1.495 17.137 13.423 13.46c-1.124-1.932-3.755-6.198-5.28-7.812-1.526-1.614-6.064-4.438-8.143-5.648z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoka);
export default __webpack_public_path__ + "static/media/LOKA.74411008ebc100cbce6c8431c80a5396.svg";
export { ForwardRef as ReactComponent };